import React, {Component} from 'react';
import {Field} from 'formik';
import {connect} from 'formik';
import {parsers} from '@neosvoc/nv-platform-core-common';
import MultipleNumber3Field from './MultipleNumber3Field';
import _ from 'lodash';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../res/translations/messages';
import Error from '../Error';
class MultipleNumber3Type extends Component {
    constructor(props) {
        super(props);
        this.validate = this.validate.bind(this);
    }

    validate(value) {
        try {
            parsers.multipleNumber3Battery(value, this.props);
        } catch (err) {
            return err.payload;
        }
    }

    render() {
        const {id, rows, value, max, formik} = this.props;
        const error = _.get(formik.errors, `${id}`);

        const sum = _.sum(Object.values(value || {}).map((v) => parseFloat(v) || 0));
        return (
            <>
                <Field name={id} id={id} rows={rows} value={value} max={max} component={MultipleNumber3Field} validate={this.validate} />
                <div className="pt20" style={{position: 'absolute', paddingTop: '32px'}}>
                    <FormattedMessage {...messages.label.total} />: {sum} / {max}
                </div>
                <div className="clear-both pt48">
                    {error && <Error {...error} /> }
                </div>
            </>
        );
    }
}

export default connect(MultipleNumber3Type);
